// export const URL ="https://devmindmedia.frappe.cloud/";

// DEV
export const URL = "https://pvadmin.thecage.com.sg/";

// LIVE
//export const URL = "https://bookadmin.thecage.com.sg/"

//export const URL ="https://thecage.upeosoft.com/";
// export const URL ="http://127.0.0.1:8024/";
